module.exports = __webpack_public_path__ + "media/images/icon_list/image-d18c7a08bac59af3c51c11090e78ba3f.svg";